interface AnalyticsFiltersProps {
  activePreset: string;
  dateRange: { date_from: string; date_to: string };
  companyTypeFilter: string;
  onPreset: (label: string, days: number) => void;
  onDateChange: (field: 'date_from' | 'date_to', value: string) => void;
  onCompanyTypeChange: (value: string) => void;
}

export function AnalyticsFilters({
  activePreset,
  dateRange,
  companyTypeFilter,
  onPreset,
  onDateChange,
  onCompanyTypeChange,
}: AnalyticsFiltersProps) {
  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-center gap-2 flex-wrap">
        <span className="text-sm font-medium text-muted-foreground">Period</span>
        {[7, 30, 60, 90].map((days) => {
          const label = `${days} Days`;
          return (
            <button
              key={label}
              type="button"
              onClick={() => onPreset(label, days)}
              className={`px-3 py-1.5 text-sm rounded-full border transition-colors ${
                activePreset === label
                  ? 'bg-primary text-primary-foreground border-primary'
                  : 'bg-background text-foreground border-border hover:bg-accent'
              }`}
            >
              {label}
            </button>
          );
        })}
      </div>
      <div className="flex items-center gap-2 flex-wrap">
        <input
          type="date"
          value={dateRange.date_from}
          onChange={(e) => onDateChange('date_from', e.target.value)}
          className="px-3 py-1.5 border border-border rounded-md bg-background text-sm"
          aria-label="From date"
        />
        <span className="text-muted-foreground text-sm">to</span>
        <input
          type="date"
          value={dateRange.date_to}
          onChange={(e) => onDateChange('date_to', e.target.value)}
          className="px-3 py-1.5 border border-border rounded-md bg-background text-sm"
          aria-label="To date"
        />
        <select
          value={companyTypeFilter}
          onChange={(e) => onCompanyTypeChange(e.target.value)}
          className="px-3 py-2 border border-border rounded-md bg-background text-sm"
          aria-label="Filter by organisation type"
        >
          <option value="">All organisations</option>
          <option value="supplier">Supplier sites</option>
          <option value="customer">Customer sites</option>
        </select>
      </div>
    </div>
  );
}
